import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { ContactComponent } from './components/contact/contact.component';
import { ResultComponent } from './components/result/result.component';
import { QuoteComponent } from './components/quote/quote.component';
import { AirComponent } from './components/air/air.component';
import { OceanComponent } from './components/ocean/ocean.component';
import { RoadComponent } from './components/road/road.component';
import { TrainComponent } from './components/train/train.component';
import { TrackComponent } from './components/track/track.component';
import { AboutComponent } from './components/about/about.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: HomeComponent, data: {title: 'General Transports Agency | Yes We Deliver Worldwide'}},
  { path: 'contact', component: ContactComponent, data: {title: 'Contact Us | General Transports Agency'}},
  { path: 'about', component: AboutComponent, data: {title: 'About Us | General Transports Agency'}},
  { path: 'track', component: TrackComponent, data: {title: 'Track Shipment | General Transports Agency'}},
  { path: 'track/result', component: ResultComponent, data: {title: 'Get a Quote | General Transports Agency'}},
  // { path: 'quote', component: QuoteComponent, data: {title: 'Get a Quote | General Transports Agency'}},
  { path: 'services/air', component: AirComponent, data: {title: 'Air Freight | General Transports Agency'}},
  { path: 'services/ocean', component: OceanComponent, data: {title: 'Ocean Freight | General Transports Agency'}},
  { path: 'services/road', component: RoadComponent, data: {title: 'Road Freight | General Transports Agency'}},
  { path: 'services/train', component: TrainComponent, data: {title: 'Train Freight | General Transports Agency'}},
  { path: '404', component: NotFoundComponent },
  {path: '**', redirectTo: '404', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
